export default {
  title: 'Search customers',
  search: 'Search',
  searchPlaceholder: 'Phone number or email',
  instructions: 'Please enter a phone number or email address',
  noResults: 'No customer found',
  tryAgain: 'Please note: phone number or email must be an exact match.',
}
